import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import {
  fetchGeneratedIdeasRequest,
  fetchGeneratedIdeasSuccess,
  fetchGeneratedIdeasFailure,
  type GeneratedIdeasResponse,
} from '../slices/generatedIdeasSlice';
import { ENDPOINTS } from '../../api/endPoints';

function* fetchGeneratedIdeasSaga(action: PayloadAction<{ restaurantId: string }>) {
  try {
    const { restaurantId } = action.payload;
    const url = `${ENDPOINTS.generateCampaign}/${restaurantId}`;

    const response: Response = yield call(fetch, url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData: { message?: string } = yield response.json();
      throw new Error(errorData.message || 'Failed to fetch generated ideas');
    }

    const data: GeneratedIdeasResponse = yield response.json();

    yield put(fetchGeneratedIdeasSuccess(data));
  } catch (error: any) {
    yield put(fetchGeneratedIdeasFailure(error.message || 'An error occurred'));
  }
}

export function* generatedIdeasSaga() {
  yield takeLatest(fetchGeneratedIdeasRequest.type, fetchGeneratedIdeasSaga);
}

export default generatedIdeasSaga;
